module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gray-back",
    staticStyle: {
      "padding": ".2rem 0 2rem 0"
    }
  }, [_c('div', {
    staticClass: "danwei-warp"
  }, [_c('div', {
    staticClass: "cover"
  }, [_c('img', {
    attrs: {
      "src": _vm.row.pic_url
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.row.baoming.danwei) + " " + _vm._s(_vm.row.baoming.saiqu))]), _vm._v(" "), _c('div', {
    staticClass: "saiqu"
  }, [_vm._v(_vm._s(_vm.row.subject_name))]), _vm._v(" "), _c('div', {
    staticClass: "duiwu"
  }, [_vm._v(_vm._s(_vm.row.baoming.mingcheng))]), _vm._v(" "), _c('div', {
    staticClass: "member"
  }, [_vm._v("运动员\n\n            "), _vm._l((_vm.row.yundongyuan), function(member, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "plain": ""
      }
    }, [_vm._v(_vm._s(member.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "member"
  }, [_vm._v("教练员\n            "), _vm._l((_vm.row.jiaolian), function(member, index) {
    return _c('van-tag', {
      key: index,
      attrs: {
        "plain": ""
      }
    }, [_vm._v(_vm._s(member.name))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "num"
  }, [_c('div', {
    staticClass: "count"
  }, [_vm._v(_vm._s(_vm.row.vote_count))]), _vm._v(" "), _c('span', [_vm._v("票")])])]), _vm._v(" "), _c('div', {
    staticClass: "savebtn"
  }, [_c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.all
    }
  }, [_vm._v("查看所有")]), _vm._v(" "), _c('van-button', {
    staticStyle: {
      "width": "3rem"
    },
    attrs: {
      "color": "linear-gradient(90deg, rgb(254, 200, 53) 0%, rgb(255, 173, 25) 100%)",
      "size": "normal",
      "round": ""
    },
    on: {
      "click": _vm.vote
    }
  }, [_vm._v("投TA一票")])], 1), _vm._v(" "), _c('LoginDialog', {
    attrs: {
      "show": _vm.loginShow
    },
    on: {
      "loginSuccess": _vm.loginSuccess,
      "loginCancel": _vm.loginCancel
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1c9c2a30","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/apps/isai/VoteDetail.vue
// module id = 2236
// module chunks = 0